import React, { useContext } from 'react';
import { DeleteOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Popconfirm, Space } from 'antd';

import SoftwareImportContext from '@totem/components/devices/software-import/SoftwareImportContext';
import SoftwareImportResults from '@totem/components/devices/software-import/SoftwareImportResults';
import SoftwareImportUpload from '@totem/components/devices/software-import/SoftwareImportUpload';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';

export const SoftwareImportExtra = () => {
  const { userProfile } = useContext(UserProfileContext);
  const { status, summary, deleting, onReset, onDeleteImported } = useContext(
    SoftwareImportContext,
  );
  const busy = status === 'validating' || status === 'uploading';
  const importedDevices = summary?.devices ?? 0;

  return (
    <Space>
      {importedDevices > 0 && (
        <Popconfirm
          title="Delete imported devices?"
          description={
            <>
              Permanently delete the {importedDevices} device(s) created by
              software imports in {userProfile.organization.name}.
              <br />
              Buildings and existing devices are not affected.
            </>
          }
          okText="Delete"
          okButtonProps={{ danger: true }}
          onConfirm={onDeleteImported}
          disabled={busy}
        >
          <Button
            danger
            icon={<DeleteOutlined />}
            loading={deleting}
            disabled={busy}
          >
            Delete Imported Devices ({importedDevices})
          </Button>
        </Popconfirm>
      )}
      {status === 'complete' && (
        <Button icon={<UploadOutlined />} onClick={onReset}>
          Import Another File
        </Button>
      )}
    </Space>
  );
};

const SoftwareImportLayout = () => {
  const { status } = useContext(SoftwareImportContext);

  return status === 'complete' ? (
    <SoftwareImportResults />
  ) : (
    <SoftwareImportUpload />
  );
};

export default SoftwareImportLayout;
